import {useEffect,useRef,useState} from 'react';

/** Optional data access shared by SVG chart families. Callers supply the same
 * rows as the plot; this component never estimates values from SVG positions. */
export function ChartDataExplorer({children,rows=[],interactive=true,label='Data',emptyLabel='—'}) {
  const [open,setOpen]=useState(false);
  const [selected,setSelected]=useState(null);
  const plot=useRef(null);
  useEffect(()=>{plot.current?.toggleAttribute('inert',!interactive)},[interactive]);
  const keys=Array.from(new Set(rows.flatMap(row=>Object.keys(row))));
  const alignment = key => rows.some(row=>typeof row[key] === "number") ? "right" : "left";
  return <div data-chart-explorer="" data-interactive={interactive}>
    <div ref={plot} style={interactive?undefined:{pointerEvents:'none'}}>{children}</div>
    {interactive&&rows.length>0&&<>
      {/* Look v3: the look lives here (it came from reference-theme.css). */}
      <button type="button" data-chart-data-toggle="" aria-expanded={open} onClick={()=>setOpen(v=>!v)}
        className="ml-auto mt-2.5 flex items-center gap-3.5 rounded-lg border border-neutral-200 bg-primary-soft/30 px-2.5 py-[7px] text-2xs font-semibold text-primary transition-colors hover:bg-primary-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30">{label}<span aria-hidden="true">{open?' −':' +'}</span></button>
      {open&&<div data-chart-data-table="" className="mt-2.5 max-h-60 overflow-auto rounded-[9px] border border-neutral-200">
        <table className="w-full text-xs"><thead className="sticky top-0 bg-neutral-50"><tr>{keys.map(key=><th key={key} scope="col" className="border-b border-neutral-200 px-3 py-[9px] text-2xs font-semibold text-neutral-500" style={{textAlign:alignment(key)}}>{key}</th>)}</tr></thead>
          <tbody>{rows.map((row,i)=><tr key={i} data-selected={selected===i||undefined} className="border-b border-neutral-100 last:border-0 data-[selected]:bg-primary-soft"
            onMouseEnter={()=>setSelected(i)} onFocus={()=>setSelected(i)}
            onClick={()=>setSelected(selected===i?null:i)}>
            {keys.map((key,j)=><td key={key} className="px-3 py-[9px] text-neutral-700" style={{textAlign:alignment(key),fontVariantNumeric:"tabular-nums",verticalAlign:"top"}} tabIndex={j===0?0:undefined}>{row[key]==null?emptyLabel:String(row[key])}</td>)}
          </tr>)}</tbody>
        </table>
      </div>}
    </>}
  </div>;
}
